import React from 'react';
import styled from 'styled-components';
const DocsPageUnorderedList = ({ ...rest }) => {
    return React.createElement(DocsPageUnorderedListWrapper, { ...rest });
};
export default DocsPageUnorderedList;
const DocsPageUnorderedListWrapper = styled.ul `
`;
//# sourceMappingURL=DocsPageUnorderedList.js.map